import { values } from '@fortem-monorepo/js-utilities';
export const DISTRIBUTION_POLICY = {
    Distributed: 'distributed',
    Accumulated: 'accumulated',
};
export const DISTRIBUTION_POLICIES = values(DISTRIBUTION_POLICY);
